export const SAVE_ASSET_DASHBOARD_TABLE_FILTERS = "SAVE_ASSET_DASHBOARD_TABLE_FILTERS";
export const CLEAR_ASSET_DASHBOARD_TABLE_FILTERS = "CLEAR_ASSET_DASHBOARD_TABLE_FILTERS";
export const SAVE_ASSET_DASHBOARD_MAP_FILTERS = "SAVE_ASSET_DASHBOARD_MAP_FILTERS";
export const CLEAR_ASSET_DASHBOARD_MAP_FILTERS = "CLEAR_ASSET_DASHBOARD_MAP_FILTERS";

export const DEFAULT_ASSET_DASHBOARD_MAP_FILTERS = {
    map_type: "site",
    map_mode: "default",
    asset_type: "with_asset",
    mapFullscreen: false
};

const ASSET_DASHBOARD_CRUMB_NAMES = ["Asset Dashboard", "Mobile Assets"];

export const isAssetDashboardCrumbName = name => ASSET_DASHBOARD_CRUMB_NAMES.includes(name);
